// extracted by mini-css-extract-plugin
module.exports = {"gridCard":"_GridCard_gridCard__mwWUX","reverse":"_GridCard_reverse__7gCic","normal":"_GridCard_normal__Z1VYA"};